import React, { useState, useEffect } from "react";
import Layout from "../../Components/Navigation/Layout";
import User from "../../Components/Admin/Users";
import AddUserModal from "../../Components/Admin/addUserModal";
import axios from "axios";
import { TableSkeleton } from "../../Components/Loader";

const Adduser = () => {
  const [users, setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res  = await axios.get("/server/baos_function/users");
        const data = res.data.data;
        setUsers(data.filter((u) => u.AdminID === null));
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Layout>
      {loading ? (
        <TableSkeleton />
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:0, maxWidth:1400, margin:"0 auto", width:"100%" }}>
          <AddUserModal users={users} setUsers={setUsers} />
          <User users={users} setUsers={setUsers} />
        </div>
      )}
    </Layout>
  );
};

export default Adduser;
